import React, { useContext } from 'react';
import '../styles/ContentStyle.css';
import { Context as MainContext } from '../context/MainContext';

import { Typography } from '@material-ui/core';

const TimeSpentMax = () => {
  const { state } = useContext(MainContext);
  return (
    <div className="ContentContainer">
      <div className="TitleContainer">
        <Typography variant="h5" noWrap>
          Hola {state.awb.consigneeName}
        </Typography>
      </div>
      <div className="MainContentContainer">
        <Typography variant="h6" className="AWBText">
          ******{state.awb.awbNumber.substring(6)}
        </Typography>
        <Typography variant="subtitle1" className="SubtitleText">
          Tu envío no ha sido recolectado, comunícate al 800-765-6345.
        </Typography>
      </div>
      <div className="AddressContainer">
        <Typography variant="body1">
          {state.station.name}: {state.station.address1}&nbsp;&nbsp;
        </Typography>
        {state.station.google_maps_id ? (
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=DHL&query_place_id=${state.station.google_maps_id}`}
          >
            <Typography variant="body1" noWrap>
              Google Maps
            </Typography>
          </a>
        ) : null}
      </div>
      <div className="ThankYouNoteContainer">
        <Typography variant="h5" noWrap>
          ¡Gracias por elegir DHL!
        </Typography>
      </div>
    </div>
  );
};

export default TimeSpentMax;
